import React from 'react';

type Props = {
  width?: string;
  height?: string;
};

/** A return arrow (↵): a line break inside a caption (PLAT-11914). */
const LineBreakIcon = ({ width = '11', height = '11' }: Props) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none">
    <path
      d="M13.5 2.5v5a2 2 0 0 1-2 2h-9M5.5 6.5l-3 3 3 3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LineBreakIcon;
